
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/developer/order-history",
      function () {
        return require("private-next-pages/developer/order-history/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/developer/order-history"])
      });
    }
  